import * as React from 'react'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import "./css/AddnewItem.css"
import { Box, FormControl, FormLabel, Grid } from '@mui/material'
import { useState, useEffect } from "react"
import axios from "axios"
import api from "../config/backend"
import { toast } from "react-toastify"

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}))

// taxtype can be "tcs" or "tds"
const NewTax = ({ taxtype, popup, setPopup, setTriggerTaxListRefresh }) => {
    const [taxList, setTaxList] = useState([])
    const [taxName, setTaxName] = useState("")
    const [taxRate, setTaxRate] = useState("")
    const [selectedTax, setSelectedTax] = useState(undefined)

    const token = localStorage.getItem("_crm__token")

    const fetchTaxList = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/tax-list`, { token, taxtype })

        if (data.success) {
            setTaxList(data.taxList)
        }
    }

    const handleCreateTax = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/create-tax`, { 
            token, 
            identifier: selectedTax,
            name: taxName,
            rate: taxRate
        })

        if (data.success) {
            setPopup(false)
            setTriggerTaxListRefresh(prev => prev + 1)
        }
        else {
            toast.error(data.message)
        }
    }

    useEffect(() => {
        fetchTaxList()
    }, [])

    return (
        <div className="_8suc">
            <Button className='btn-btn-tcs' onClick={() => setPopup(true)}>
                New {taxtype.toUpperCase()} Tax
            </Button>
            <BootstrapDialog
                onClose={() => setPopup(false)}
                aria-labelledby="customized-dialog-title"
                open={popup}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Manage {taxtype.toUpperCase()}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setPopup(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Grid className='Main_Grid' container spacing={2}>
                        <Grid item xs={6}>
                            <div className='Form-fields'>
                                <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                    <FormLabel className='lable_feilds' component="legend">Tax Name*</FormLabel>
                                </FormControl>
                                <Box display="flex" alignItems="center">
                                    <input 
                                        type="text" 
                                        name="tax-name" 
                                        value={taxName}
                                        onChange={e => setTaxName(e.target.value)}
                                        className="custom-input-popup" 
                                        placeholder="Tax Name" 
                                        style={{ marginRight: '10px' }} 
                                    />
                                </Box>
                            </div>
                            <div>
                                <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                    <FormLabel className='lable_feilds' component="legend">Nature of Collection*</FormLabel>
                                </FormControl>
                                <Box display="flex" alignItems="center">
                                    <select 
                                        name="Tax" 
                                        className="custom-input-popup" 
                                        id="cars"
                                        value={selectedTax}
                                        onChange={e => setSelectedTax(e.target.value)}
                                    >
                                        {taxList.map((tax, index) => {
                                            return (
                                                <option key={index} value={tax._id}>{tax.section}</option>
                                            )
                                        })}
                                    </select>
                                </Box>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div>
                                <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                    <FormLabel className='lable_feilds' component="legend">Rate (%)*</FormLabel>
                                </FormControl>
                                <Box display="flex" alignItems="center">
                                    <input 
                                        type="text" 
                                        name="tax-rate" 
                                        value={taxRate}
                                        onChange={e => setTaxRate(e.target.value)}
                                        className="custom-input-popup" 
                                        placeholder="Rate" 
                                        style={{ marginRight: '10px' }} 
                                    />
                                </Box>
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button className='btn-btn-save' autoFocus onClick={() => handleCreateTax()}>
                        Save
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    )
}

export default NewTax
